import { render, staticRenderFns } from "./ImportarCertificado.vue?vue&type=template&id=64883982&"
import script from "./ImportarCertificado.vue?vue&type=script&lang=js&"
export * from "./ImportarCertificado.vue?vue&type=script&lang=js&"
import style0 from "./ImportarCertificado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports